import './TeamFaces.scss';

// Past this many the rest collapse into a "+N" circle
const MAX_FACES = 5;

const initials = (name = '') =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');

const TeamFaces = ({ users = [] }) => {
  if (!users.length) return null;

  const shown = users.slice(0, MAX_FACES);
  const rest = users.length - shown.length;

  return (
    <div className="TeamFaces" aria-hidden="true">
      {shown.map((user, i) => (
        <span key={user._id} className={`face face--tint${i % 3}`}>
          {initials(user.name)}
        </span>
      ))}
      {rest > 0 && <span className="face face--rest">+{rest}</span>}
    </div>
  );
};

export default TeamFaces;
